import React from 'react'
import AddUserForm from '../../components/Users/AddUserForm'

const AddUser = () => {
  return (
    <div>
      <AddUserForm></AddUserForm>
    </div>
  )
}

export default AddUser